/*
 * Copyright (c) webzuu Michał Stambulski 2018.
 */

import axios from "axios";

import { token } from "util/auth/check";

import {
  enforceHttps,
  parseQueryString,
  serializeQueryParams
} from "util/uri";

import env from 'util/env';
import {setSession} from "util/auth/auth0";

const pendingRequests = {};

const defaultEndpoint = env('ZUU_CONSOLE_API_ENDPOINT');

const isDebugEnabled = () => {
  return document.cookie.indexOf("XDEBUG_SESSION") > -1;
};

const makeHeaders = requestHeaders => {
  let headers = { ...requestHeaders };
  headers["Content-type"] = "application/json";
  return authHeaders(headers);
};

export function authHeaders(prevHeaders) {
  let headers = {...prevHeaders};
  let persistedState = localStorage.getItem('reduxState');
  persistedState = JSON.parse(persistedState);
  if (persistedState && persistedState.auth) {
    let apiToken = persistedState.auth.api_key;
    if (apiToken) {
      headers["X-zuu-api-key"] = apiToken;
    }
  }
  let authToken = token();
  if (authToken && !headers.Authorization) {
    headers["Authorization"] = "Bearer " + authToken;
  }
  return headers;
}

const makeUrl = (path, queryParams = null) => {
  let parts = [];
  if (path.indexOf("//") === -1) parts.push(defaultEndpoint);
  if (queryParams && Object.values(queryParams).length > 0) {
    let [pathBase, query] = path.split('?');
    let pathQuery = {};
    if (query) pathQuery = parseQueryString(query);
    let allParams = {...queryParams, ...pathQuery};
    parts.push(pathBase);
    parts.push("?" + serializeQueryParams(allParams));
  } else {
    parts.push(path);
  }
  let url = parts.join("/");
  return enforceHttps(url);
};

const buildRequest = (
  path,
  method = "get",
  queryParams,
  data,
  headers,
  options
) => {
  const requestMethod = method !== "get" ? "post" : method;
  let query = { ...queryParams };
  if (!path) return false;
  let isHttp = path.indexOf('http') === 0;
  if (!isHttp && isDebugEnabled()) query.XDEBUG_SESSION_START = "docker";
  let requestParams = {
    url: makeUrl(path, query),
    method: requestMethod,
    headers: !isHttp ? makeHeaders(headers) : {},
    ...options
  };
  if (method === "upload") {
    requestParams.method = requestMethod;
    requestParams.data = data;
    return requestParams;
  }
  if (requestMethod === "post") {
    requestParams.data = {
      _method: method,
      data: data
    };
  }
  return requestParams;
};

export const api = (
  basePath,
  headers,
  baseQuery,
  path,
  method = "get",
  query = {},
  data = {},
  options = {}
) => {
  let pathParts = [];
  if (basePath) pathParts.push(basePath);
  if (path) pathParts.push(path);
  const requestParams = buildRequest(
    pathParts.join('/'),
    method,
    { ...baseQuery, ...query },
    data,
    headers,
    options
  );
  return axios(requestParams);
};

export const request = (...args) => {
  const req = buildRequest(...args);
  return new Promise((resolve, reject) => {
      if (pendingRequests[req.url]){
        resolve(null);
        return;
      }
      pendingRequests[req.url] = true;
      axios(req).then(response=>{
        pendingRequests[req.url] = false;
        let headers = response.headers;
        if (headers['x-zuu-access-token']) {
          setSession({
            access_token: headers['x-zuu-access-token'],
            expires_in: headers['x-zuu-access-token-expires-in']
          });
          console.log(headers);
        }
        resolve(response);
      }).catch(error=>{
        pendingRequests[req.url] = false;
        reject(error);
      });
  });
};
